import { useEffect, useRef } from "react";

export function useOutsideClickHandler(refs, callback) {
    useEffect(() => {
        function handleClickOutside(event) {

            if (Array.isArray(refs)) {
                let missMatch = 0;
                refs.forEach(reference => {
                    if (reference.current && !reference.current.contains(event.target)) {
                        missMatch++;
                    }
                })
                missMatch === refs.length && callback();
            } else {
                if (refs.current && !refs.current.contains(event.target)) {
                    callback();
                }
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [refs]);
}

export function useInterval(callback, delay) {
    const savedCallback = useRef();

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
        function tick() {
            savedCallback.current();
        }

        if (delay !== null) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
}
